import moment from "moment";

export const isMidnight = (iso: string | null | undefined): boolean => {
  if (!iso) return true;
  const m = moment(iso);
  return m.hour() === 0 && m.minute() === 0 && m.second() === 0;
};

export const formatCategorySchedule = (
  start: string | null | undefined,
  end: string | null | undefined
): string => {
  if (!start) return "";

  const s = moment(start);
  const e = end ? moment(end) : null;
  const bothMidnight = isMidnight(start) && (!end || isMidnight(end));

  if (bothMidnight) {
    if (!e) return s.format("D MMM YYYY");
    return `${s.format("D MMM YYYY")} – ${e.format("D MMM YYYY")}`;
  }

  if (!e) return `${s.format("D MMM YYYY, HH:mm")}`;

  if (s.isSame(e, "day")) {
    return `${s.format("D MMM YYYY, HH:mm")} – ${e.format("HH:mm")}`;
  }
  return `${s.format("D MMM YYYY HH:mm")} – ${e.format("D MMM YYYY HH:mm")}`;
};

export type FeeWindow = { startDate?: string | null; endDate?: string | null };

export type FeeWindowStatus =
  | { kind: "always"; label: "Always available" }
  | { kind: "active"; label: "Active now" }
  | { kind: "upcoming"; label: string }
  | { kind: "ended"; label: "Ended" };

export const feeWindowStatus = (window: FeeWindow, now: Date = new Date()): FeeWindowStatus => {
  const start = window.startDate ? new Date(window.startDate) : null;
  const end = window.endDate ? new Date(window.endDate) : null;

  if (!start && !end) return { kind: "always", label: "Always available" };
  if (end && end < now) return { kind: "ended", label: "Ended" };
  if (start && start > now) {
    const days = Math.ceil((start.getTime() - now.getTime()) / (1000 * 60 * 60 * 24));
    return { kind: "upcoming", label: `Starts in ${days} day${days === 1 ? "" : "s"}` };
  }
  return { kind: "active", label: "Active now" };
};
